<template>
  <v-data-table-server
    v-model:options="pagination"
    :headers="headers"
    :items="requests"
    :page="pagination.page"
    :items-length="total"
    :loading="loading"
    class="elevation-1 nowrap-headers"
    :items-per-page="pagination.itemsPerPage"
    :items-per-page-options="[
      { value: 5, title: '5' },
      { value: 10, title: '10' },
      { value: 25, title: '25' },
      { value: 50, title: '50' },
    ]"
    items-per-page-text="Rows per page"
    @update:options="updatePagination"
  >
    <template #progress>
      <v-progress-linear indeterminate color="red" />
    </template>
    <template #item="{ item, index }">
      <tr
        :class="{ tableRowColorSelected: index === activeRow }"
        class="tableRowColor"
        @click="activeRow = index"
      >
        <!--ID-->
        <td>
          <span>
            {{ item._id.slice(item._id.length - 4, item._id.length) }}
          </span>
        </td>
        <!--STATUS-->
        <td>
          <v-chip
            class="ma-1"
            label
            outlined
            :color="index === activeRow ? 'white' : getStatus(item).color"
          >
            <span> {{ getStatus(item).status }} </span>
          </v-chip>
        </td>
        <!--USER-->
        <td>
          <span v-if="item.user.details">{{ item.user.details.name }} </span>
          <span v-if="item.user.details">{{ item.user.details.surname }} </span>
        </td>
        <!--REQUESTS-->
        <td>
          {{ item.requests.length }}
          {{
            item.requests.length === 1
              ? $t("part_requests.headers._part")
              : $t("part_requests.headers._parts")
          }}
        </td>
        <!--INSTITUTIONS-->
        <td>
          <v-row align-center>
            <v-chip
              v-if="item.assignedInstitutions.length > 0"
              :color="item.color.rgb"
              :dark="item.color.dark"
              variant="outlined"
            >
              {{ getInstitutionName(item.assignedInstitutions) }}
            </v-chip>
            <span v-if="item.assignedInstitutions.length > 1">
              (+{{ item.assignedInstitutions.length - 1 }}
              {{
                item.assignedInstitutions.length - 1 === 1
                  ? $t("part_requests.headers._other")
                  : $t("part_requests.headers._others")
              }})
            </span>
          </v-row>
        </td>
        <!--CREATION DATE-->
        <td>
          <div class="text-center text-truncate pb-2">
            {{ formatDate(item.dateCreated) }}
          </div>
        </td>
        <!--ACTIONS-->
        <td>
          <v-row align-center justify-center>
            <!--VIEW DETAILS-->
            <v-btn icon variant="text" @click="viewRequestDetails(item)">
              <v-icon color="grey-darken-2"> mdi-view-list </v-icon>
            </v-btn>
            <!--VIEW OFFERS-->
            <v-btn
              icon
              variant="text"
              @click="viewOffers(item._id, item.assignedInstitutions)"
            >
              <v-icon color="grey-darken-2"> mdi-tag </v-icon>
            </v-btn>
          </v-row>
        </td>
      </tr>
      <tr v-if="requests && requests.length < 1">
        <td :colspan="headers.length" class="text-center pa-4">
          <v-alert type="info" border="left" color="red lighten-2" text>
            No data available.
          </v-alert>
        </td>
      </tr>
    </template>
  </v-data-table-server>
</template>

<script>
import moment from "moment";
import store from "../../store";

import getRequest from "../../api/getRequest";
// import putRequest from '../../api/putRequest';

function generateRandomColor() {
  const random = () => Math.floor(Math.random() * Math.floor(255));
  const color = { r: random(), g: random(), b: random() };
  const brightness = (color.r * 299 + color.g * 587 + color.b * 114) / 1000;
  return {
    rgb: `rgb(${color.r},${color.g},${color.b})`,
    dark: brightness < 155,
  };
}

export default {
  props: ["selected"],
  data: () => ({
    loading: false,
    activeRow: null,
    requests: [],
    total: 0,
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["dateCreated"],
      sortBy: [{ key: "dateCreated", order: "desc" }],
      sortDesc: [true],
    },
    headers: [
      { title: "ID", sortable: false, key: "_id" },
      { title: "Status", sortable: false, key: "status" },
      { title: "User", sortable: false, key: "user" },
      { title: "Parts", sortable: false, key: "parts" },
      { title: "Institutions", sortable: false, key: "institutions" },
      { title: "Date Created", sortable: true, key: "dateCreated" },
      { title: "Actions", sortable: false, key: "actions" },
    ],
    loadingInstitutions: false,
    loadingSale: false,
    institutions: [],
    selectedInstitutions: [],
  }),
  watch: {
    "$props.selected": {
      handler() {
        this.getPartRequests();
      },
    },
    pagination: {
      handler() {
        this.getPartRequests();
      },
      deep: true,
    },
  },
  created() {
    this.getInstitutions();
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.headers[0].tile = this.$t("part_requests.headers.id");
      this.headers[1].tile = this.$t("part_requests.headers.status");
      this.headers[2].tile = this.$t("part_requests.headers.user");
      this.headers[3].tile = this.$t("part_requests.headers.parts");
      this.headers[4].tile = this.$t(
        "part_requests.headers.assigned_institutions",
      );
      this.headers[5].tile = this.$t("part_requests.headers.date_created");
      this.headers[6].tile = this.$t("part_requests.headers.actions");
    },
    getPartRequests() {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "dateCreated",
        order: "desc",
      };
      getRequest(
        "/part-request",
        `category=3&status=${this.$props.selected}&institution_id=${
          this.$store.getters.institutionId
        }&role=${this.$store.getters.role}&limit=${
          this.pagination.itemsPerPage
        }&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
      )
        .then((response) => {
          this.requests = response.partRequests;
          this.requests = response.partRequests.map((r) => ({
            ...r,
            color: generateRandomColor(),
          }));
          this.total = response.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    viewRequestDetails(data) {
      this.$emit("view-details", data);
    },
    viewOffers(id, assignedInstitutions) {
      this.$emit("view-offers", { id, assignedInstitutions, editable: false });
    },
    getInstitutions() {
      this.loadingInstitutions = true;
      getRequest("/institution")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitutions = false;
        })
        .catch(() => {
          this.loadingInstitutions = false;
        });
    },
    getInstitutionName(value) {
      if (!value || value.length === 0) return "None";

      const index = value.findIndex(
        (v) =>
          v.id._id.toString() === this.$store.getters.institutionId.toString(),
      );

      if (index > -1) return value[index].id.title;
      return value[0].id.title;
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
    updatePagination(options) {
      this.pagination = {
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 5,
        groupBy:
          options.groupBy && options.groupBy.length
            ? options.groupBy
            : ["dateCreated"],
        sortBy:
          options.sortBy && options.sortBy.length
            ? options.sortBy
            : { key: "dateCreated", order: "desc" },
        sortDesc:
          options.sortDesc && options.sortDesc.length
            ? options.sortDesc
            : [true],
      };
      this.activeRow = null;
    },
    getStatus(item) {
      const institution = item.assignedInstitutions.find(
        (i) =>
          i.id._id.toString() === this.$store.getters.institutionId.toString(),
      ); // eslint-disable-line max-len

      // Only for an institution. (must be called before checking status ??)
      if (
        this.$store.getters.role === "InstitutionAdmin" ||
        this.$store.getters.role === "InstitutionManager" ||
        this.$store.getters.role === "User" ||
        this.$store.getters.role === "EbayOperator"
      ) {
        if (institution && institution.expired)
          return {
            color: "red",
            status: this.$t("part_requests.status.expired"),
          };
        if (institution && institution.refused)
          return {
            color: "red",
            status: this.$t("part_requests.status.not_found"),
          };
        if (
          institution &&
          institution.offer.proposed &&
          institution.offer.refused
        )
          return {
            color: "red",
            status: this.$t("part_requests.status.refused"),
          };
        if (
          institution &&
          !institution.offer.proposed &&
          institution.offer.refused
        )
          return {
            color: "orange",
            status: this.$t("part_requests.status.no_offer"),
          };
      }

      if (item.status === 3 || item.status === 3.2) {
        // Sold
        if (
          this.$store.getters.role === "LekoAdmin" ||
          this.$store.getters.role === "LekoEmployee" ||
          this.$store.getters.role === "SuperAdmin"
        ) {
          return {
            color: "green",
            status: this.$t("part_requests.status.sold"),
          };
        } else if (
          this.$store.getters.role === "InstitutionAdmin" ||
          this.$store.getters.role === "InstitutionManager" ||
          this.$store.getters.role === "User" ||
          this.$store.getters.role === "EbayOperator"
        ) {
          if (institution && institution.offer.selected)
            return {
              color: "green",
              status: this.$t("part_requests.status.sold"),
            };
        }
      }

      // Global
      if (item.status === 3.1)
        return {
          color: "orange",
          status: this.$t("part_requests.status.returned"),
        };
      if (item.status === 4)
        return {
          color: "orange",
          status: this.$t("part_requests.status.expired"),
        };
      if (item.status === 5)
        return {
          color: "red",
          status: this.$t("part_requests.status.refused"),
        };

      return { color: "white", status: "" };
    },
  },
};
</script>
